// extracted by mini-css-extract-plugin
module.exports = {"Popup":"Popup_Popup__3kpk0","minimum":"Popup_minimum__2JyHK","MinBtn":"Popup_MinBtn__1rVt2","content":"Popup_content__inz0I"};